<template>
	<v-content>
		<v-container width="100%" ml-auto mr-auto pl-3 pr-3 pb-12 pt-12>
			<div class="title-landing title-landing--size-2 text-center">Добавить дело</div>
			<form style="max-width: 800px; margin: 0 auto; text-align: center;">
				<v-autocomplete outline
					v-model="model.court_id"
					:items="selectSearchCourtItems"
					:loading="courtIsLoading"
					:search-input.sync="selectSearchCourt"
					item-text="translate.ru.name"
					:no-data-text="'Ничего не найдено'"
       				item-value="id"
					hide-no-data
					hide-selected
					:label="'Суд'"
					:placeholder="'Поиск Суда'"
				></v-autocomplete>
				<v-text-field
					v-model="model.uid"
					label="Номер дела"
					required
				></v-text-field>
				<v-menu
					ref="menu1"
					v-model="menu1"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field
							v-model="dateFormatted"
							label="Дата дела"
							hint="ММ/ДД/ГГГГ"
							persistent-hint
							@blur="model.date = parseDate(dateFormatted)"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker v-model="model.date" no-title locale="ru-ru" @input="menu1 = false"></v-date-picker>
				</v-menu>
				<v-text-field
					v-model="model.plaintiff_person"
					label="Истец ФИО"
					required
				></v-text-field>
				<v-text-field
					v-model="model.plaintiff_company"
					label="Истец компания"
					required
				></v-text-field>
				<v-text-field
					v-model="model.plaintiff_lawyer"
					label="Истец адвокат"
					required
				></v-text-field>
				<v-text-field
					v-model="model.defendant_person"
					label="ФИО ответчика"
					required
				></v-text-field>
				<v-text-field
					v-model="model.defendant_company"
					label="Ответчик компания"
					required
				></v-text-field>
				<v-text-field
					v-model="model.defendant_lawyer"
					label="Адвокат ответчика"
					required
				></v-text-field>
				<v-text-field
					v-model="model.judge"
					label="Судья ФИО"
					required
				></v-text-field>
				<v-file-input
					label="Загрузить файл"
				 	show-size
					v-model="model.file"
				></v-file-input>
				<v-textarea
					v-model="model.judgement"
					label="Решение суда текст"
				></v-textarea>
				<v-btn class="mr-4" @click="submit">Отправить</v-btn>
			</form>
		</v-container>

		<v-snackbar
			v-model="snackbar"
			:color="snackcolor"
			:timeout="6000"
		>
			{{ snacbarText }}
		</v-snackbar>
	</v-content>
</template>

<script>

export default {
	name: 'AddDocument',

	data () {
		return {
			name: '',
			email: '',
			select: null,
			selectSearchCourtItems: [],
			selectSearchCourt: null,
			dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
			menu1: false,
			items: [
				'Item 1',
				'Item 2',
				'Item 3',
				'Item 4',
			],
			checkbox: false,
			courtIsLoading: false,
			model: {
				date: new Date().toISOString().substr(0, 10),
				court_id: '',
				uid: '',
				file: null,
				judgement: '',
				judge: "",
				defendant_lawyer: "",
				defendant_company: "",
				defendant_person: "",
				plaintiff_lawyer: "",
				plaintiff_company: "",
				plaintiff_person: "",
			},
			snackbar: false,
			snackcolor: "success",
			snacbarText: ''
		}
	},

	components: {
	},

	created () {
	},

  	computed: {
		translates () {
			return this.$store.getters.TRANSLATES;
		},

		computedDateFormatted () {
			return this.formatDate(this.model.date)
		},
	},

	methods: {
		formatDate (date) {
			if (!date) return null

			const [year, month, day] = date.split('-')
			return `${month}/${day}/${year}`
		},
		parseDate (date) {
			if (!date) return null

			const [month, day, year] = date.split('/')
			return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
		},
		submit () {
			let formData = new FormData();

			if (this.model.file === null) {
				delete this.model.file;
			}

			for (let key in this.model) {
				formData.append(key, key === 'type' ? this.model[key].text : this.model[key]);
			}

			this.$api.post('/admin/api/documents-moderation', formData).then((resp) => {
				this.snacbarText = "Документ отправлен на модерацию!";
				this.snackcolor = "success";
				this.snackbar = true;
				this.model = {
					date: new Date().toISOString().substr(0, 10),
					court_id: '',
					uid: '',
					file: null,
					judgement: '',
					judge: "",
					defendant_lawyer: "",
					defendant_company: "",
					defendant_person: "",
					plaintiff_lawyer: "",
					plaintiff_company: "",
					plaintiff_person: ""
				};
			}, (err) => {
				this.snacbarText = err.data.notyMessage;
				this.snackcolor = "error";
				this.snackbar = true;
			})
		}
	},

	watch: {
		'model.date' (val) {
			this.dateFormatted = this.formatDate(this.model.date)
		},
		selectSearchCourt (val) {
			if (this.courtIsLoading) return;

			this.courtIsLoading = true;

			this.$api.get('/admin/api/dictionaries/courts', {
				name: val
			}).then((resp) => {
				this.selectSearchCourtItems = resp.data.data;
				this.courtIsLoading = false;
			}).catch((resp) => {
				console.log(resp);
				this.courtIsLoading = false;
			});
		},
	}
}
</script>

<style lang="scss">
</style>
